import React, { useEffect, useState } from 'react'
import { getAllPendingRequest, grantRequest, logout } from '../../api.service/user.service';
import { AgGridReact } from 'ag-grid-react';
import { Button } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import './admin.css'
import ModalWrapper from '../../widgets/modal/modal';
import AuthUserVerification from '../../pages/authUserVerification';
import Home from '../home/home';
import Navbar from '../navbar/navbar';
import { useNavigate } from 'react-router-dom';
import FileUploaderDownloader from '../../widgets/fileUploaderDownloader/fileUploaderDownloader';

interface EmiratesId {
    id: string;
    nationality: string;
    dob: string;
}

interface UserData {
    did: string;
    name: string;
    email: string;
    emirates_id: EmiratesId;
    telephone: string;
    appId: string;
    viewDetails: boolean
}

function Admin() {
    const navigate = useNavigate();
    const [rowData, setRowData] = useState<UserData[]>([])
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [userData, setUserData] = useState()
    const [auditCandidateName, setAuditCandidateName] = useState<any>()
    const [isAudit, setIsAudit] = useState<boolean>(false)

    console.log(rowData, "Row Dataaaaaaaaaaa")

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const fetchPendingData = () => {
        getAllPendingRequest().then(resp => {
            console.log(resp, "response")
            if (resp) {
                setRowData(resp.data)
            }
        }, err => {
            console.log("Error", err);
            logout();
        })
    }

    useEffect(() => {
        fetchPendingData()
    }, [])

    const dateTimeConverter = (timestamp: number) => {
        const localDate = new Date(timestamp).toLocaleDateString();
        return localDate
    }

    const colDef: ColDef[] = [
        {
            headerName: 'App Id',
            field: 'app_id',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Did',
            field: 'did',
            flex: 1,
            minWidth: 300
        },
        {
            headerName: 'Id',
            field: 'id',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Role',
            field: 'role',
            flex: 1,
            minWidth: 100
        },
        {
            headerName: 'Create Date',
            field: 'ts',
            flex: 1,
            cellRenderer: (params: any) => {
                return <div>{dateTimeConverter(params.data.ts)}</div>
            },
            minWidth: 150
        },
        {
            headerName: 'Till Date',
            field: 'till_date',
            flex: 1,
            cellRenderer: (params: any) => {
                return <div>{dateTimeConverter(params.data.till_date)}</div>
            },
            minWidth: 100
        },
        {
            headerName: 'Action',
            field: '',
            cellRenderer: (params: any) => {
                console.log(params, "Paramsssssssssssssss")
                return (
                    <div className='button-wrapper1'>
                        {
                            params.data.granted === false ? <>
                                <Button variant="contained" style={{ height: '30px', width: '85px' }} onClick={() => handleApproved(params)}>Approve</Button>
                                {/* <Button variant="contained" color="error" style={{ height: '30px' }} onClick={() => handleReject(params)}>Reject</Button> */}
                            </> : 'Approve'
                        }


                    </div >
                );
            }
        }

    ]

    const handleApproved = (data: any) => {
        setUserData(data)
        handleOpenModal()
    }

    const handleReject = (data: any) => {

    }

    const handleResponse = (params: any, date: any) => {
        console.log(params, "DDDDDDDDDDDDD")
        // setRowData(prevData =>
        //     prevData.map(row =>
        //         row.did === params.data.did ? { ...row, viewDetails: !row.viewDetails } : row
        //     )
        // );



        grantRequest(params.data.did, params.data.id, date).then((result: any) => {
            console.log(result, "Resulttttttttyyyyyyyy")
            if (result) {
                handleCloseModal();
                fetchPendingData()
            }
        })


    }

    const handleAudit = (params: any) => {
        console.log(params, 'Paramsmsssssssssssssssssss')
        setIsAudit(params.audit)
        setAuditCandidateName({ 'name': params.name, 'id': params.id })
    }

    const handleBack = () => {
        setIsAudit(false)
    }

    console.log(rowData, "RowDatadddddddddddddddd")

    return (
        <div className='main-container'>
            <Navbar isAdmin={true} />
            <div style={{ height: 'calc(100% - 70px)' }}>
                <div style={{ height: '50%', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '10px' }}>
                    <div style={{ height: 'calc(100% - 68px)' }}>
                        <div className='heading'>
                            <h2>Requests</h2>
                            <FileUploaderDownloader />
                        </div>
                        <div className='table-container'>
                            <div className='container-100'>
                                <AgGridReact
                                    className="ag-theme-alpine"
                                    rowData={rowData}
                                    columnDefs={colDef}
                                    rowHeight={40}
                                    headerHeight={40}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <div style={{ height: '50%', width: '100%' }}>
                    <div className='container-100'>
                        <div className='user-heading'>
                            <h2>
                                {isAudit ? 'Audit Log:' : 'User'} {' '}
                                {isAudit && (
                                    <>
                                        {auditCandidateName.name}{' '}
                                        (<span className='customer-id'>{auditCandidateName.id}</span>)
                                    </>
                                )}
                            </h2>
                            {isAudit ? <Button variant='contained' onClick={handleBack}>Back</Button> : ''}
                        </div>
                        <div style={{ height: 'calc(100% - 68px)' }}>
                            <Home onAudit={handleAudit} isAuditData={isAudit} />
                        </div>
                    </div>
                </div>
            </div>
            <ModalWrapper open={openModal} close={handleCloseModal} children={<AuthUserVerification onClose={handleCloseModal} data={userData} handleResponse={handleResponse} />} />
        </div>
    )
}

export default Admin
